<template>
  <a href="#main-content" class="skip-link" @click.prevent="skipToMainContent">
    {{ t("common.skip_to_main_content") }}
  </a>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  name: "SkipLink",
  setup() {
    const { t } = useI18n();

    const skipToMainContent = () => {
      const main = document.getElementById("main-content");
      if (!main) return;
      main.focus();
    };

    return { t, skipToMainContent };
  },
};
</script>
